import Button from "../../../independent/Button";
import Confirm from "./Confirm";


const EditModeButtons = ({ toggleEditModeHandler, subModalMount, closeModal, closeSubModal, handleUpdateHistory, formData }) => {


  return (
    <>
      <Button name={"SAVE"}
              className={"notheme"}
              confirm={true}
              onClick={() => {
                handleUpdateHistory(formData, subModalMount, closeModal, closeSubModal);
                // toggleEditModeHandler(false);
              }}
      />
      <Button name={"CANCEL"}
              className={"notheme"}
              onClick={() => {
                subModalMount(
                  <Confirm closeSubModal={closeSubModal}
                           closeModal={closeModal}
                           title={"WARNING"}
                           message={"You have unsaved changes. Are you sure you want to discard your edits?"}
                           callback={() => {
                             closeSubModal();
                             toggleEditModeHandler(false);
                           }}
                  />
                )
              }}
      />

    </>
  )


}

export default EditModeButtons;
